// Existing product-album encoding, shared by the album and quick intake.
// Images remain data URLs in product.photos; no separate upload service.
export const compressImageFile = (file, maxSize = 900, quality = 0.82) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const image = new Image();
    image.onload = () => {
      const scale = Math.min(1, maxSize / Math.max(image.width, image.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(image.width * scale));
      canvas.height = Math.max(1, Math.round(image.height * scale));
      canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL('image/jpeg', quality));
    };
    image.onerror = () => reject(new Error('圖片讀取失敗，請改選 JPG 或 PNG 圖片'));
    image.src = reader.result;
  };
  reader.onerror = () => reject(new Error('圖片讀取失敗'));
  reader.readAsDataURL(file);
});
